import { StateReducers } from './types/StateReducers'

export const selectState = (state: StateReducers): StateReducers => state
